import { characters } from "@/mocks/content";

export default function CharacterSection() {
  return (
    <section id="characters" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <div className="max-w-2xl" data-reveal>
          <h2 className="font-heading font-semibold text-2xl md:text-3xl text-foreground-950">
            角色图鉴：这类故事里常见的四种人物
          </h2>
          <p className="mt-3 text-foreground-600 leading-8">
            年轻母亲题材里，人物关系往往围绕四个位置展开：主角、孩子、长辈与关键人物。
            理解他们的立场，剧情里的很多选择就说得通了。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {characters.map((c) => (
            <article
              key={c.name}
              data-reveal
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200"
            >
              <div className="w-full h-56 md:h-64 bg-background-200 overflow-hidden">
                <img
                  src={c.image}
                  alt={`${c.name} 的角色插画`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-4">
                <h3 className="font-heading font-semibold text-base text-foreground-950">
                  {c.name}
                </h3>
                <p className="mt-1 text-[11px] text-primary-600">{c.role}</p>
                <p className="mt-2 text-xs text-foreground-600 leading-6">{c.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}